import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, ArrowRight, Zap, RefreshCw } from 'lucide-react';
export function ResetSlide() {
  return <div className="h-full flex flex-col md:flex-row gap-12 items-center" data-id="element-340">
      {/* Left Column: Text Content */}
      <div className="flex-1 space-y-8" data-id="element-341">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-6" data-id="element-342">
          <div className="flex items-center gap-3 text-purple-600 font-mono text-sm tracking-wider uppercase" data-id="element-343">
            <RefreshCw className="w-4 h-4" data-id="element-344" />
            Market Shift
          </div>

          <ul className="space-y-6" data-id="element-345">
            <li className="flex items-start gap-4" data-id="element-346">
              <div className="mt-1 p-1.5 rounded bg-red-50 text-red-600" data-id="element-347">
                <TrendingDown className="w-5 h-5" data-id="element-348" />
              </div>
              <div data-id="element-349">
                <h3 className="text-xl font-semibold text-gray-900 mb-1" data-id="element-350">
                  SaaS Panic
                </h3>
                <p className="text-gray-500" data-id="element-351">
                  IQVIA -15%, broader stocks -27% to -51%.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-4" data-id="element-352">
              <div className="mt-1 p-1.5 rounded bg-orange-50 text-orange-600" data-id="element-353">
                <Zap className="w-5 h-5" data-id="element-354" />
              </div>
              <div data-id="element-355">
                <h3 className="text-xl font-semibold text-gray-900 mb-1" data-id="element-356">
                  Per-seat models obsolete
                </h3>
                <p className="text-gray-500" data-id="element-357">
                  AI reduces users, breaking traditional pricing.
                </p>
              </div>
            </li>

            <li className="flex items-start gap-4" data-id="element-358">
              <div className="mt-1 p-1.5 rounded bg-purple-50 text-purple-600" data-id="element-359">
                <ArrowRight className="w-5 h-5" data-id="element-360" />
              </div>
              <div data-id="element-361">
                <h3 className="text-xl font-semibold text-gray-900 mb-1" data-id="element-362">
                  Shift to Service-as-Software
                </h3>
                <p className="text-gray-500" data-id="element-363">
                  Outcome-as-Agentic models taking over.
                </p>
              </div>
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="p-6 rounded-xl bg-purple-50 border border-purple-200" data-id="element-364">
          <div className="text-sm text-purple-600 mb-2 font-medium" data-id="element-365">
            Valuation Reset SaS
          </div>
          <div className="flex items-baseline gap-2" data-id="element-366">
            <span className="text-4xl font-bold text-gray-900" data-id="element-367">20x+</span>
            <span className="text-gray-500" data-id="element-368">ARR standard</span>
          </div>
          <div className="text-sm text-gray-400 mt-1" data-id="element-369">
            Top AI-native 25–50x revenue
          </div>
        </motion.div>
      </div>

      {/* Right Column: IQVIA Stock Chart */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.4
    }} className="flex-1 w-full relative h-[400px] rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-370">
        <img src="https://cdn.magicpatterns.com/uploads/eE9jNCnmNXKNdWmMuCLWUc/Screenshot_2026-02-10_at_20.52.42.png" alt="IQVIA Holdings stock chart showing -3.87% decline" className="w-full h-full object-cover object-top" data-id="element-371" />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white via-white/80 to-transparent p-4 pt-8" data-id="element-372">
          <div className="flex items-center justify-between" data-id="element-373">
            <div className="flex items-center gap-2 text-sm text-red-600 font-semibold" data-id="element-374">
              <TrendingDown className="w-4 h-4" data-id="element-375" />
              IQVIA (IQV) — SaaS model under pressure
            </div>
            <div className="text-xs text-gray-400" data-id="element-376">Source: TradingView</div>
          </div>
        </div>
      </motion.div>
    </div>;
}